import script from "./AgrupacionesExperienciasCollection.vue?vue&type=script&setup=true&lang=js"
export * from "./AgrupacionesExperienciasCollection.vue?vue&type=script&setup=true&lang=js"

import "./AgrupacionesExperienciasCollection.vue?vue&type=style&index=0&id=3535581a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3535581a"]])

export default __exports__